<div class="content-wrapper flex flex-col tk-bg-gray-5 h-full">

  <div *ngIf="!isStatementVisible" class="p-4 flex align-middle bg-white flex justify-between">
    <span class="font-semibold text-xl">{{'handover.header' | translate}}</span>

    <span *ngIf="hasAccessToHandover" class="ml-4 flex items-center text-sm cursor-pointer" (click)="onShowStatement()">
      <div class="tk-i-edit w-3.5 h-3.5 mr-2"></div>
      <span class="tk-c-blue">{{'handover.edit-worker-statement' | translate}}</span>
    </span>
  </div>

  <div
    [ngClass]="{ 'flex-1': !hasAccessToHandover }" 
    class="flex w-full"
  >
    <app-handover-add *ngIf="!hasAccessToHandover"></app-handover-add>

    <ng-container *ngIf="hasAccessToHandover">
      <handovermod-worker-statement *ngIf="isStatementVisible" class="w-full"></handovermod-worker-statement>

      <div *ngIf="!isStatementVisible" class="flex flex-col">
        <handovermod-vehicles-filter style="width: 340px"></handovermod-vehicles-filter>
        <handovermod-vehicles-list></handovermod-vehicles-list>
      </div>
  
      <handovermod-right-panel *ngIf="!isStatementVisible" class="w-full"></handovermod-right-panel>  
    </ng-container>
  </div>
</div>
